import {
  HEAD_HEIGHT,
  MOVE_Y,
  TIMELINE_SHOW_LIMIT,
  VIDEO_CENTER_OFFSET,
  TIMELINE_SHOW_OFFSET,
} from '../constants';
import * as Features from './Features';

const spot = {
  selected: false,
  position: 1,
};
const calcVars = {
  width: 0,
  height: 0,
};
const centerOffsetGoal = {
  y: 0,
};
const centerOffset = {
  y: 0,
};
const mousePosition = {
  y: 0.5,
};
let timelineAlpha = 1.0;

// ----------------------------------------------------
// Spot
// ----------------------------------------------------

// note - not ideal - duplicate with redux stuff
export const setSceneVideo = (videoId, position) => {
  spot.selected = videoId.length > 0;
  spot.position = position;
};

// ----------------------------------------------------
// Resize
// ----------------------------------------------------

export const updateSize = (width, height) => {
  calcVars.width = width;
  calcVars.height = height;
};

// ----------------------------------------------------
// Mouse
// ----------------------------------------------------

export const updateMousePosition = y => {
  mousePosition.y = Math.min(
    Math.max((y - HEAD_HEIGHT) / calcVars.height, 0),
    1
  );
};

// ----------------------------------------------------
// Loop
// ----------------------------------------------------

// note - calling from main scene is not really ideal

const setCenterNormal = () => {
  timelineAlpha = 1.0;
  if (Features.features.mobile) {
    centerOffsetGoal.y = 0;
  } else {
    centerOffsetGoal.y = (1 - mousePosition.y * 2) * (calcVars.height * MOVE_Y);
  }
};

const setCenterVideo = () => {
  timelineAlpha = 0.0;
  if (spot.position > 0) {
    // up
    centerOffsetGoal.y = calcVars.height * VIDEO_CENTER_OFFSET;
    if (
      !Features.features.mobile &&
      !Features.features.safari &&
      mousePosition.y > 1 - TIMELINE_SHOW_LIMIT
    ) {
      timelineAlpha = 1.0;
      centerOffsetGoal.y = calcVars.height * 0.5 - TIMELINE_SHOW_OFFSET;
    }
  } else {
    // dn
    centerOffsetGoal.y = calcVars.height * -VIDEO_CENTER_OFFSET;
    if (
      !Features.features.mobile &&
      !Features.features.safari &&
      mousePosition.y < TIMELINE_SHOW_LIMIT
    ) {
      timelineAlpha = 1.0;
      centerOffsetGoal.y = -calcVars.height * 0.5 + TIMELINE_SHOW_OFFSET;
    }
  }
};

export const loop = () => {
  if (spot.selected) {
    setCenterVideo();
  } else {
    setCenterNormal();
  }

  if (Features.features.mobile) {
    // no easing on mobile
    centerOffset.y = centerOffsetGoal.y;
  } else {
    // ease + check limits
    centerOffset.y += (centerOffsetGoal.y - centerOffset.y) * 0.09;
    if (Math.abs(centerOffset.y - centerOffsetGoal.y) < 0.01) {
      centerOffset.y = centerOffsetGoal.y;
    }
  }
};

// ----------------------------------------------------
// Get
// ----------------------------------------------------

export const getMousePositionY = () => mousePosition.y;
export const getCenterOffsetY = () => centerOffset.y;
export const getTimelineAlpha = () => timelineAlpha;



// WEBPACK FOOTER //
// ./src/utils/Mover.js